import { vehicleMarkerTemplate } from "./marker"

export class MapsRegistry {
  constructor(map, loader, bounds) {
    this.map = map
    this._loader = loader
    this.markers = new Map()
    this.bounds = bounds;
  }

  updateAll(vehicles) {
    const seenIds = new Set()

    vehicles.forEach(vehicle => {
      seenIds.add(vehicle.id)

      if (this.markers.has(vehicle.id)) {
        this.update(vehicle)
      } else {
        this.create(vehicle)
      }
    })
    this.cleanup(seenIds)
  }

  async create(data) {
    const { Marker } = await this._loader.importLibrary('marker');
    const { InfoWindow } = await this._loader.importLibrary('maps');
    const { LatLng } = await this._loader.importLibrary('core');

    const content = vehicleMarkerTemplate(data);
    const position = new LatLng(data.device_info.latitude, data.device_info.longitude);

    const marker = new Marker({
        position: position,
        map: this.map,
        title: data.vehicle.plates || data.vehicle.ship_name,
        animation: google.maps.Animation.DROP,
        vehicleData: data.vehicle
      });

    const infoWindow = new InfoWindow({
      content: content,
    });

    this.markers.set(data.vehicle.id, { marker, infoWindow })

    marker.addListener('click', () => {
      this.onMarkerClick(data.vehicle, marker, infoWindow);
    });

    marker.addListener('mouseover', () => {
      infoWindow.open(this.map, marker);
    });

    marker.addListener('mouseout', () => {
      if (this.clicked) {
        return;
      }
      if (this.selectedVehicle?.id !== data.vehicle.id) {
        infoWindow.close();
      }
    });

    this.bounds.extend(position);
    this.map.fitBounds(this.bounds);
  }

  onMarkerClick(vehicle, marker, infoWindow) {
    this.markers.forEach((item, id) => {
      if (id !== vehicle.id) item.infoWindow.close();
    });

    infoWindow.open(this.map, marker);
    this.selectedVehicle = vehicle;
    this.map.panTo(marker.getPosition());
    this.map.setZoom(16);
  }

  update(vehicle) {
    const entry = this.markers.get(vehicle.id)

    entry.marker.position = {
      lat: vehicle.lat,
      lng: vehicle.lng
    }

    const newContent = vehicleMarkerTemplate(vehicle)
    entry.content.replaceWith(newContent)
    entry.content = newContent
  }

  panToMarker(id){
    let item = this.markers.get(parseInt(id));
    this.map.panTo(item.marker.getPosition());
  }

  cleanup(seenIds) {
    for (const [id, entry] of this.markers.entries()) {
      if (!seenIds.has(id)) {
        entry.marker.map = null
        this.markers.delete(id)
      }
    }
  }

}
